import { createFileRoute } from '@tanstack/react-router';
import Players from 'src/pages/Organization/Reports/Players';

export const Route = createFileRoute('/$organizationSlug/reports/players/')({
  component: Players,
});
